import { Injectable } from '@angular/core';
import { IFilterListService } from './ifilter-list.service';
import { map } from 'rxjs';
import { Selectable } from 'src/app/shared/models/types/selectable.type';
import { PhotographerQueries } from 'src/app/models/shared/enums/get-query';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WrapperResultGraphQL } from 'src/app/models/shared/types/wrapper-result-graphql.type';
import { PageInfo } from 'src/app/models/shared/types/page-info.type';
import { PhotographerStatus } from 'src/app/models/common/photographer-status.model';

@Injectable({
  providedIn: 'root'
})
export class PhotographerStatusFilterService extends IFilterListService<PhotographerStatus> {
  pageInfo: PageInfo = { hasPreviusPage: false, hasNextPage: false, startCursor: null, endCursor: null };

  search(searchText: string, variables, isFirst: boolean): void {
    if (searchText || isFirst) this.pageInfo = { ...this.pageInfo, endCursor: null, startCursor: null };

    this.graphQlService.getData<PhotographerStatus>(PhotographerQueries.GET_PHOTOGRAPHER_STATUS_NO_IDS)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map(res => res['data']['photographerStatus'])
      )
      .subscribe({
        next: (res: WrapperResultGraphQL<PhotographerStatus>) => {
          let datasource: Array<Selectable<PhotographerStatus>> = [];
          datasource = res.nodes.map(el => ({ ...el, disabled: false, selected: false, displayId: el.id, displayName: el.name }));

          this.datasource.next(datasource);
        }
      })
  }
}
